import { ArtistFestivalType, mapArtistType, useFindArtistSuspense } from '@api';
import {
  TouringCard,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
  TouringDataTable,
} from '@common';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/artists/$id.shows';
import { useArtistFestivalsColumns } from './hooks';

export const ArtistFestivals: React.FC = () => {
  const { t } = useTranslation('artistDetailsShows');
  const { id } = Route.useParams();
  const { data: artist } = useFindArtistSuspense(id, {
    query: { select: (data) => mapArtistType(data.data) },
  });
  const { festivals } = artist;
  const { columns } = useArtistFestivalsColumns();

  return (
    <TouringCard data-testid="artist-festivals-container">
      <TouringCardHeader>
        <TouringCardTitle>{t('ARTIST_FESTIVALS.TITLE')}</TouringCardTitle>
      </TouringCardHeader>
      <TouringCardSection>
        <TouringDataTable<ArtistFestivalType>
          records={festivals}
          columns={columns}
          withTableBorder={false}
          withColumnBorders={false}
          noHeader
          highlightOnHover={false}
        />
      </TouringCardSection>
    </TouringCard>
  );
};
